import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, DateRangePicker, cents, centsToUnits } from '@systemeio/ui';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { FunnelStatisticsFilterInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface';
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface StatisticsTabTableLayoutProps {
  setFilter: React.Dispatch<React.SetStateAction<FunnelStatisticsFilterInterface>>;
  filter: FunnelStatisticsFilterInterface;
  currency: CurrencyEnum;
  totalSales: number | null;
  averageCartValue: number | null;
  children: JSX.Element;
}
function StatisticsTabTableLayout(t0) {
  const $ = _c(44);
  const {
    filter,
    setFilter,
    currency,
    totalSales,
    averageCartValue,
    children
  } = t0;
  const {
    user,
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MobileSettingsHeader type={FunnelStepSettingTabsEnum.stats} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.funnel.statistics.gross");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="font-inter text-text-primary text-base lg:text-lg">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currency || $[6] !== totalSales || $[7] !== user?.dashboardLocale) {
    t4 = currencyFormat(centsToUnits(cents(totalSales || 0)), currency, user?.dashboardLocale);
    $[5] = currency;
    $[6] = totalSales;
    $[7] = user?.dashboardLocale;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="font-inter text-brand-primary text-xl font-bold lg:text-3xl">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.funnel.statistics.average_cart_value");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="font-inter text-text-primary text-base lg:text-lg">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== averageCartValue || $[19] !== currency || $[20] !== user?.dashboardLocale) {
    t9 = currencyFormat(centsToUnits(cents(averageCartValue || 0)), currency, user?.dashboardLocale);
    $[18] = averageCartValue;
    $[19] = currency;
    $[20] = user?.dashboardLocale;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div className="font-inter text-brand-primary text-xl font-bold lg:text-3xl">{t9}</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex flex-col gap-2">{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t6) {
    t12 = <div className="flex flex-col gap-4 lg:flex-row lg:gap-20">{t6}{t11}</div>;
    $[27] = t11;
    $[28] = t6;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== setFilter) {
    t13 = date => {
      setFilter({
        date
      });
    };
    $[30] = setFilter;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = user?.timezone;
  const t15 = user?.createdAt;
  let t16;
  if ($[32] !== filter.date || $[33] !== intlLocale || $[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <DateRangePicker date={filter.date} onChange={t13} timezone={t14} createdAt={t15} intlLocale={intlLocale} />;
    $[32] = filter.date;
    $[33] = intlLocale;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t12 || $[39] !== t16) {
    t17 = <div className="flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between">{t12}{t16}</div>;
    $[38] = t12;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== children || $[42] !== t17) {
    t18 = <div className="mb-5 flex flex-col gap-8 px-[15px] lg:px-[15px]">{t1}{t17}{children}</div>;
    $[41] = children;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
export default StatisticsTabTableLayout;